// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__12dDV","header":"MessagesList_header__17ZFa","chat":"MessagesList_chat__NZtcu"};